<script setup lang="ts">
defineProps<{
  name: 'group' | 'scenarios' | 'isolation' | 'analytics'
}>()
</script>

<template>
  <span class="process-icon" aria-hidden="true">
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g v-if="name === 'group'">
        <circle cx="9" cy="8" r="3" />
        <path d="M3.75 18.5v-1.25A4.25 4.25 0 0 1 8 13h2a4.25 4.25 0 0 1 4.25 4.25v1.25" />
        <path d="M15.5 5.35a3 3 0 0 1 0 5.3M16.5 13.25a4.25 4.25 0 0 1 3.75 4.22v1.03" />
      </g>
      <g v-else-if="name === 'scenarios'">
        <path d="M6.5 4.5h8l3 3v12h-11z" />
        <path d="M14.5 4.5v3h3M9.5 11h5M9.5 14h5M9.5 17h3" />
        <path d="M3.5 7.5v12h10" />
      </g>
      <g v-else-if="name === 'isolation'">
        <path d="M12 3.5 19 6v5.25c0 4.3-2.8 7.45-7 9.25-4.2-1.8-7-4.95-7-9.25V6z" />
        <rect x="9" y="10.5" width="6" height="5" rx="1" />
        <path d="M10.5 10.5V9a1.5 1.5 0 0 1 3 0v1.5" />
      </g>
      <g v-else>
        <path d="M4 19.5h16M6.5 17v-4M11.5 17V9M16.5 17V5" />
        <path d="m5.5 9.5 4-3 3 1.5 5-5" />
        <path d="M15.5 3h2v2" />
      </g>
    </svg>
  </span>
</template>
